var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_404"},[_c('div',{staticClass:"page_404-content"},[_c('c-image',{attrs:{"iUrl":"icon-404","iClass":"icon","iWidth":"260","iHeight":"98"}}),_c('h3',[_vm._v("Error，页面找不到啦！请点击返回首页~")]),_c('c-button',{attrs:{"bClass":"btn"},on:{"btnClick":_vm.onPageToHome}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }